import { useState } from "react";
import api from "@api";
import { Helmet } from "react-helmet-async";
function ForgotPassword() {
 const [email, setEmail] = useState("");
 const [message, setMessage] = useState("");
 const [loading, setLoading] = useState(false);
 const [sent, setSent] = useState(false);

 const handleSubmit = async (e) => {
  e.preventDefault();

  try {
   setLoading(true);
   const res = await api.post("/api/auth/forgot-password", { email });
   setMessage(res.data.message);
   setSent(true);
  } catch (error) {
   setMessage("Something went wrong.");
  } finally {
   setLoading(false);
  }
 };

 return (
  
  <div style={{
   minHeight: "100vh",
   display: "flex",
   justifyContent: "center",
   alignItems: "center",
   background: "#f5f7fa"
  }}>
   <Helmet>
    <title>Forgot Password | SportingHip</title>
    <meta name="robots" content="noindex,nofollow" />
   </Helmet>
   <div style={{
    background: "white",
    padding: "3rem",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    width: "100%",
    maxWidth: "420px"
   }}>
    <h2 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
     Forgot Password
    </h2>

    {!sent && (
     <form
      onSubmit={handleSubmit}
      style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
     >
      <input
       type="email"
       placeholder="Enter your email"
       value={email}
       onChange={(e) => setEmail(e.target.value)}
       required
       style={{
        padding: "0.75rem",
        borderRadius: "8px",
        border: "1px solid #ddd"
       }}
      />

      <button
       type="submit"
       disabled={loading}
       style={{
        padding: "0.75rem",
        borderRadius: "8px",
        border: "none",
        background: "#111",
        color: "white",
        cursor: "pointer"
       }}
      >
       {loading ? "Sending..." : "Send Reset Link"}
      </button>
     </form>
    )}

    {message && (
     <p style={{
      marginTop: "1rem",
      textAlign: "center",
      color: "#16a34a"
     }}>
      {message}
     </p>
    )}
   </div>
  </div>
 );
}

export default ForgotPassword;